class WaldweltCart {

	constructor() {

		// Virtual shopping cart
		this.cart = {};

		// Ticket configuration
		// Prices have been last updated on 2025-01-27
		this.entranceTickets = {

			// Number of adult tickets, default: 1
			ticketcountAdult: 1,

			// Number of child tickets, default: 0
			ticketcountChild: 0,

			// Price for adults
			ticketPriceAdult: 15.5,

			// Price for children
			ticketPriceChild: 11.5,

			// Group price for adults
			ticketPriceAdultGroup: 13.5,

			// Group price for children
			ticketPriceChildGroup: 10.5,

			// Minimum size of a group
			ticketcountAdultGroup: 15,

			// Temporary sum of adult tickets
			totalAdultPrice: 0,

			// Temporary sum of child tickets
			totalChildPrice: 0,


		};

		this.totals = {

			ticketTotal: 0, // Gesamtsumme der Ticketkosten
			workshopTotal: 0, // Gesamtsumme der Workshopkosten
			Total: 0, // Gesamtsumme aus Ticketkosten und gebuchte Workshops


		};

		this.cartIsVaild = false; // a validator
		this.cartCalculates = true; // ob der Warenkorb berechnet werden soll oder ob Anfragepreise enthalten sind
	}


	// Methode zum Hinzufügen eines Artikels zum Warenkorb
	addToCart( item ) {
		if ( !this.cart[ item.packageId ] ) {
			// Speichern des Artikels unter der packageId als Schlüssel
			this.cart[ item.packageId ] = item;
			console.log( `Artikel hinzugefügt: ${item.angebotsname}` );
			this.addItemToDOM( item );


			if ( item.priceModel === 'on_request' ) {
				// priceElement.textContent = `auf Anfrage`;
				item.price_total = 0;
				this.cartCalculates = false;
				this.calculateGrandTotal();
			}


		} else {
			//console.log( `Artikel ${item.angebotsname} ist bereits im Warenkorb.` );
		}


		// Button visuell als ausgewählt markieren
		const cartButton = document.querySelector( `#cartbutton${item.packageId}` );
		if ( cartButton ) {
			cartButton.classList.add( 'selected' );
			cartButton.innerHTML = '<span>x</span>';

		} else {

		}


		this.updateFloatingCart();
		// console.log( this.cart ); // Nur zu Testzwecken, um den Warenkorb anzuzeigen
	}

	// Methode zum Erstellen der Zeile mit den Basisinformationen
	createCartItemRow( item ) {
		const row = document.createElement( 'div' );
		row.classList.add( 'row', 'cartitem', 'py-3', 'mx-0', 'mb-2' );
		row.setAttribute( 'data-packageId', item.packageId );

		const nameColumn = document.createElement( 'div' );
		nameColumn.classList.add( 'col-md-6', 'col-10', 'title', 'd-flex', 'align-items-center' );
		nameColumn.textContent = item.angebotsname;
		row.appendChild( nameColumn );

		return row;
	}

	// Methode zum Erstellen der Select-Box für die Anzahl der Personen
	configureSelectBox( item ) {
		const parametersColumn = document.createElement( 'div' );
		parametersColumn.classList.add( 'col-6', 'col-md-4', 'parameters', 'd-flex', 'align-items-center' );

		const selectBox = document.createElement( 'select' );
		selectBox.classList.add( 'form-control', 'custom-select-box', 'm-0' );
		selectBox.setAttribute( 'name', `anzahl_personen_${item.packageId}` );

		// Bestimme die Mindest- und Höchstanzahl
		const minAttendeeCount = parseInt( item.attendeeCount ) || 1;
		const maxAttendeeCount = isNaN( parseInt( item.maxAttendeeCount ) ) || !item.maxAttendeeCount ?
			minAttendeeCount + 30 :
			parseInt( item.maxAttendeeCount );

		// Hinzufügen der Optionen basierend auf der Mindest- und Maximalanzahl
		for ( let i = minAttendeeCount; i <= maxAttendeeCount; i++ ) {
			const option = document.createElement( 'option' );
			option.value = i;
			option.textContent = `${i} Person${i > 1 ? 'en' : ''}`;

			if ( i === minAttendeeCount ) {
				option.selected = true;
			}

			selectBox.appendChild( option );
		}

		parametersColumn.appendChild( selectBox );
		return parametersColumn;
	}

	createRemoveButton( item ) {
		const actionsColumn = document.createElement( 'div' );
		actionsColumn.classList.add( 'col-md-2', 'actions', 'text-end' );

		const svgIcon = `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
				<path d="M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm80 64l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16z"/>
			</svg>`;

		const removeButton = document.createElement( 'button' );
		removeButton.classList.add( 'x', 'm-0', 'removebutton' );
		removeButton.innerHTML = svgIcon + ' <span class="d-none d-lg-inline ml-2">Löschen</span>';

		removeButton.setAttribute( 'data-action', 'remove-item' );
		removeButton.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			this.removeItemFromDOM( item.packageId );
		} );

		actionsColumn.appendChild( removeButton );
		return actionsColumn;
	}


	// Funktion zum Erstellen des Preis-Elements
	createPriceElement() {
		const priceColumn = document.createElement( 'div' );
		priceColumn.classList.add( 'col-2', 'price', 'd-flex', 'align-items-center', 'justify-content-end' );
		priceColumn.textContent = '0,-'; // Initialer Preis wird auf 0 gesetzt
		// console.log( 'Preis-Element erstellt mit initialem Wert: 0,-' );
		return priceColumn;
	}

	// Methode zum Aktualisieren des Preises basierend auf dem Preis-Modell und der packageId
	updateItemPrice( packageId ) {

		// If article not in cart: return
		if ( !this.cart[ packageId ] ) {
			// console.log( `Fehler: Kein Artikel mit der ID ${packageId} im Warenkorb gefunden.` );
			return;
		}

		const item = this.cart[ packageId ];
		const priceElement = document.querySelector( `.cartitem[data-packageId="${packageId}"] .price` );

		if ( !priceElement ) {
			// console.log( `Fehler: Konnte Preis-Element für ${packageId} nicht finden.` );
			return;
		}

		if ( item.priceModel === 'on_request' ) {
			priceElement.textContent = `auf Anfrage`;
			item.price_total = 0;
			return;
		}

		const selectedCount = item.selected_attendees || 1; // Standardmäßig 1 Person

		// Staffelpreislogik, wenn tieredPricing vorhanden ist
		if ( item.tieredPricing && Array.isArray( item.tieredPricing ) && item.tieredPricing.length > 0 ) {

			// Finde den zutreffenden Staffelpreis basierend auf der Anzahl der Teilnehmer
			let applicableTier = item.tieredPricing[ 0 ]; // Setze den ersten als Standard
			for ( const tier of item.tieredPricing ) {
				if ( selectedCount >= tier.min_persons ) {
					applicableTier = tier; // Aktualisiere, wenn die Mindestanzahl erreicht wird
				}
			}

			if ( item.priceModel === 'group_price' ) {
				// Setze den Gruppenpreis basierend auf der Staffelung
				item.price_total = applicableTier.price_per;
				// console.log( `Gruppenpreis für ${item.angebotsname}: ${item.price_total},-` );
			} else {
				// Preis pro Person basierend auf der Staffelung
				item.price_total = applicableTier.price_per * selectedCount;
				// console.log( `Preis pro Person für ${item.angebotsname} bei ${selectedCount} Person(en): ${item.price_total},-` );
			}
		} else {
			// Fallback, wenn keine Staffelpreise vorhanden sind
			if ( item.priceModel === 'group_price' ) {
				item.price_total = item.pricePerGroup;
				// console.log( `Gruppenpreis ohne Staffelung für ${item.angebotsname}: ${item.price_total},-` );
			} else {
				item.price_total = item.pricePerPerson * selectedCount;
				// console.log( `Einzelpreis ohne Staffelung für ${item.angebotsname} bei ${selectedCount} Person(en): ${item.price_total},-` );
			}
		}

		// Preis im DOM aktualisieren
		// priceElement.textContent = `${this.formatPrice(item.price_total)} Euro`;
		priceElement.textContent = `${this.formatPrice(item.price_total)}`;

		this.updateMaxWorkshopAttendees();
		this.calculateGrandTotal();
	}






	// Methode zum Hinzufügen des Event-Listeners zur Preisaktualisierung
	configurePriceUpdate( item, selectBox, priceElement ) {
		// Überprüfe, ob das Item im Warenkorb existiert
		if ( !this.cart[ item.packageId ] ) {
			// console.log( `Fehler: Kein Artikel mit der ID ${item.packageId} im Warenkorb gefunden.` );
			return;
		}

		// Konsolenmeldung für die initiale Auswahl
		console.log( `Initiale Auswahl für ${item.angebotsname}: ${selectBox.value}` );

		// Event-Listener für das Ändern der Anzahl der Personen
		selectBox.addEventListener( 'change', ( event ) => {
			const selectedCount = parseInt( event.target.value, 10 ); // Nutze event.target.value und wandle in Zahl um
			console.log( `Personenanzahl geändert zu: ${selectedCount} für ${item.angebotsname} (ID: ${item.packageId})` );

			// Setze die neue Personenanzahl im Warenkorb
			if ( this.cart[ item.packageId ] ) {
				this.cart[ item.packageId ].selected_attendees = selectedCount;
			} else {
				// console.log( `Fehler: Artikel mit ID ${item.packageId} existiert nicht im Warenkorb.` );
			}

			// Preisaktualisierung aufrufen und die neuen Werte im cart speichern
			this.updateItemPrice( item.packageId );
			this.updateFloatingCart();
		} );

		// Initiale Preisberechnung
		// console.log( `Initiale Preisberechnung für ${item.angebotsname}` );

		// Setze den anfänglichen Wert für selected_attendees, falls nicht vorhanden
		if ( !this.cart[ item.packageId ].selected_attendees ) {
			this.cart[ item.packageId ].selected_attendees = this.cart[ item.packageId ].attendeeCount || 1; // Verwende attendeeCount oder Standardwert 1
		}

		// Preisaktualisierung
		this.updateItemPrice( item.packageId );
	}



	addItemToDOM( item ) {
		const cartItemsContainer = document.querySelector( '.cartitems' );
		const placeholder = cartItemsContainer.querySelector( '.placeholder' );

		// Erstellen der einzelnen Spalten mit neuen Klassen
		const row = document.createElement( 'div' );
		row.classList.add( 'row', 'cartitem', 'py-3', 'mx-1' );
		row.setAttribute( 'data-packageid', item.packageId );

		const titleColumn = document.createElement( 'div' );
		titleColumn.classList.add( 'col-10', 'col-lg-5', 'title', 'order-1', 'd-flex', 'align-items-center' );
		titleColumn.textContent = item.angebotsname;

		const selectBoxColumn = this.configureSelectBox( item );
		selectBoxColumn.classList.add( 'col-6', 'col-lg-3', 'parameters', 'order-3', 'order-lg-2' );

		const removeButtonColumn = this.createRemoveButton( item );
		removeButtonColumn.classList.add( 'col-2', 'col-lg-2', 'actions', 'order-2', 'order-lg-3' );

		const priceColumn = this.createPriceElement();
		priceColumn.classList.add( 'col-6', 'col-lg-2', 'price', 'order-4' );

		// Füge die Spalten in die Zeile ein
		row.appendChild( titleColumn );
		row.appendChild( selectBoxColumn );
		row.appendChild( removeButtonColumn );
		row.appendChild( priceColumn );

		// Füge die Zeile in das DOM (in das Formular) ein
		cartItemsContainer.appendChild( row );

		// Placeholder ausblenden
		if ( placeholder ) {
			placeholder.classList.add( 'd-none' );
		}

		// Füge den Preis-Update Event-Listener hinzu, der auch im cart speichert
		this.configurePriceUpdate( item, selectBoxColumn.querySelector( 'select' ), priceColumn );
	}


	// Methode zum Entfernen eines Artikels aus dem DOM
	removeItemFromDOM( packageId ) {



		const cartItem = document.querySelector( `.cartitem[data-packageId="${packageId}"]` );
		if ( cartItem ) {
			cartItem.remove();
			// console.log( `Artikel mit ID ${packageId} wurde entfernt.` );
		}

		// Entferne das Element auch aus dem internen Warenkorb-Objekt
		delete this.cart[ packageId ];

		// Button zurücksetzen
		const cartButton = document.querySelector( `#cartbutton${packageId}` );
		if ( cartButton ) {
			cartButton.classList.remove( 'selected' );
			cartButton.innerHTML = '<span>&nbsp;</span>';

		} else {

			// console.log("--- konnte den button nicht entfernen");
		}

		this.updateMaxWorkshopAttendees();
		this.checkForOnRequestPriceModel();

		// Prüfen, ob der Warenkorb leer ist und ggf. Placeholder wieder anzeigen
		if ( Object.keys( this.cart ).length === 0 ) {
			const cartItemsContainer = document.querySelector( '.cartitems' );
			const placeholder = cartItemsContainer.querySelector( '.placeholder' );
			if ( placeholder ) {
				placeholder.classList.remove( 'd-none' );
			}
		}

		this.updateFloatingCart();
	}


	/**
	 * Adds behavior to optional ticket selectbox (for children and adults)
	 */
	configureEntranceTickets() {

		const adultSelect = document.querySelector( `select[name="anzahl_eintritt_erwachsene"]` );
		const childSelect = document.querySelector( `select[name="anzahl_eintritt_kinder"]` );
		const priceElement = document.querySelector( `.cartentrance .price` );

		// Optional ticket price for adults
		adultSelect.addEventListener( 'change', ( event ) => {
			this.entranceTickets.ticketcountAdult = parseInt( event.target.value, 10 ) || 0;
			// console.log( `Anzahl Eintrittskarten Erwachsene: ${this.entranceTickets.ticketcountAdult}` );

			// Aktualisiere den Preis für Eintrittskarten
			this.updateEntrancePrice( priceElement );

		} );

		// Optional ticket price for children
		childSelect.addEventListener( 'change', ( event ) => {
			this.entranceTickets.ticketcountChild = parseInt( event.target.value, 10 ) || 0;
			// console.log( `Anzahl Eintrittskarten Kinder: ${this.entranceTickets.ticketcountChild}` );

			// Aktualisiere den Preis für Eintrittskarten
			this.updateEntrancePrice();

		} );

	}



	// Update the price of tickets for adults and children
	updateEntrancePrice() {

		// Abort if ticket calculation is disabled
		if ( !this.enableTicketCalculation ) {
			return;
		}

		// Define input fields to display price
		const priceElement = document.querySelector( `.cartentrance .price` );
		if ( !priceElement ) return;

		const priceDisplayAdults = document.querySelector( `.cartentrance .price-erwachsene` );
		const priceDisplayKids = document.querySelector( `.cartentrance .price-kids` );


		// Read amount of tickets
		const adultTickets = this.entranceTickets.ticketcountAdult || 0;
		const childTickets = this.entranceTickets.ticketcountChild || 0;

		let totalTickets = adultTickets + childTickets;

		// Calculate with group ticket price
		if ( totalTickets >= this.entranceTickets.ticketcountAdultGroup ) {

			this.entranceTickets.totalAdultPrice = adultTickets * this.entranceTickets.ticketPriceAdultGroup;
			this.entranceTickets.totalChildPrice = childTickets * this.entranceTickets.ticketPriceChildGroup;

		} else {

			// Conventional ticket calculation with regular ticket price
			this.entranceTickets.totalAdultPrice = adultTickets * this.entranceTickets.ticketPriceAdult;
			this.entranceTickets.totalChildPrice = childTickets * this.entranceTickets.ticketPriceChild;
		}

		const totalPrice = this.entranceTickets.totalAdultPrice + this.entranceTickets.totalChildPrice;

		this.totals.ticketTotal = totalPrice;
		// priceElement.textContent = `${this.formatPrice(totalPrice)} Euro`;
		priceElement.textContent = `${this.formatPrice(totalPrice)}`;

		priceDisplayAdults.textContent = `${this.formatPrice(this.entranceTickets.totalAdultPrice)}`;
		priceDisplayKids.textContent = `${this.formatPrice(this.entranceTickets.totalChildPrice)}`;

		this.calculateGrandTotal();
	}



	calculateGrandTotal() {

		const totalPriceElement = document.querySelector( '.carttotal .price' );


		if ( this.cartCalculates === false ) {

			this.totals.Total = 0;
			totalPriceElement.textContent = `auf Anfrage`;

			return;
		}






		// Finde das Preis-Element für das Grand Total

		if ( !totalPriceElement ) {
			// console.log( 'Fehler: Konnte das Preis-Element für das Grand Total nicht finden.' );
			return;
		}

		// Berechne die Summe der ausgewählten Workshops
		let workshopTotal = 0;
		for ( const packageId in this.cart ) {
			if ( this.cart.hasOwnProperty( packageId ) ) {
				workshopTotal += this.cart[ packageId ].price_total || 0;
			}
		}
		this.totals.workshopTotal = workshopTotal;



		// Addiere die Ticket-Gesamtsumme zu den Workshop-Kosten
		const ticketTotal = this.totals.ticketTotal || 0;

		// Berechne das Grand Total
		const grandTotal = workshopTotal + ticketTotal;

		// Speichere das Grand Total in der entsprechenden Variable
		this.totals.Total = grandTotal;

		// Konsolenmeldung zur Überprüfung
		// console.log( `Workshop-Gesamtpreis: ${workshopTotal}` );
		// console.log( `Ticket-Gesamtpreis: ${ticketTotal}` );
		// console.log( `Grand Total (Gesamtpreis): ${grandTotal}` );

		// Aktualisiere das DOM-Element mit dem Grand Total
		//totalPriceElement.textContent = `${grandTotal},-`;
		// totalPriceElement.textContent = `${this.formatPrice(grandTotal)} Euro`;
		totalPriceElement.textContent = `${this.formatPrice(grandTotal)}`;

	}

	updateMaxWorkshopAttendees() {
		let maxAttendees = 0;

		// Durchlaufe alle Workshops im Cart
		for ( const packageId in this.cart ) {
			if ( this.cart.hasOwnProperty( packageId ) ) {
				const attendees = this.cart[ packageId ].selected_attendees || 0;
				if ( attendees > maxAttendees ) {
					maxAttendees = attendees;
				}
			}
		}

		// Speichere die maximale Anzahl der Teilnehmer
		this.maxWorkshopAttendees = maxAttendees;

		// Konsolenmeldung zur Überprüfung
		// console.log( `Größte Anzahl von Teilnehmern aus allen Workshops: ${this.maxWorkshopAttendees}` );

		// Rufe die Funktion auf, die die Auswahlmöglichkeiten für die Eintrittskarten anpasst
		this.updateEntranceTicketOptions();
	}

	// Methode zum Aktualisieren der Auswahlmöglichkeiten der Eintrittskarten
	updateEntranceTicketOptions() {
		const adultSelect = document.querySelector( `select[name="anzahl_eintritt_erwachsene"]` );
		const childSelect = document.querySelector( `select[name="anzahl_eintritt_kinder"]` );

		if ( !adultSelect || !childSelect ) {
			return;
		}

		const currentAdultValue = parseInt( adultSelect.value, 10 );
		const currentChildValue = parseInt( childSelect.value, 10 );

		let minAdultTickets = this.enableTicketCalculation ? 1 : 0; // Mindestanzahl der Erwachsenen
		let minChildTickets = 0; // Mindestanzahl für Kinder
		let maxTickets = this.maxWorkshopAttendees + 20;

		// Leere das Select-Element für Erwachsene, um neue Optionen hinzuzufügen
		adultSelect.innerHTML = '';
		let valueIsValid = false;





		// maxWorkshopAttendees

		for ( let i = 0; i <= maxTickets; i++ ) {
			const option = document.createElement( 'option' );
			option.value = i;
			option.textContent = `${i} ${i === 1 ? 'Erwachsener' : 'Erwachsene'}`;
			if ( i === this.maxWorkshopAttendees ) {
				option.selected = true;
				valueIsValid = true;
			}
			adultSelect.appendChild( option );
		}

		// for ( let i = minAdultTickets; i <= maxTickets; i++ ) {
		// 	const option = document.createElement( 'option' );
		// 	option.value = i;
		// 	option.textContent = `${i} ${i === 1 ? 'Erwachsener' : 'Erwachsene'}`;
		// 	if ( i === currentAdultValue ) {
		// 		option.selected = true;
		// 		valueIsValid = true;
		// 	}
		// 	adultSelect.appendChild( option );
		// }
		if ( !valueIsValid && adultSelect.options.length > 0 ) {
			adultSelect.options[ 0 ].selected = true;
		}

		// Leere das Select-Element für Kinder, um neue Optionen hinzuzufügen
		childSelect.innerHTML = '';
		valueIsValid = false;
		for ( let i = minChildTickets; i <= maxTickets; i++ ) {
			const option = document.createElement( 'option' );
			option.value = i;
			option.textContent = `${i} ${i === 1 ? 'Kind' : 'Kinder'}`;
			if ( i === currentChildValue ) {
				option.selected = true;
				valueIsValid = true;
			}
			childSelect.appendChild( option );
		}
		if ( !valueIsValid && childSelect.options.length > 0 ) {
			childSelect.options[ 0 ].selected = true;
		}

		// console.log( `Die Auswahlmöglichkeiten für Eintrittskarten Erwachsene wurden aktualisiert: ${minAdultTickets} - ${maxTickets}` );
		// console.log( `Die Auswahlmöglichkeiten für Eintrittskarten Kinder wurden aktualisiert: ${minChildTickets} - ${maxTickets}` );

		// Trigger den 'change' Event, um die Preisberechnung auszulösen
		adultSelect.dispatchEvent( new Event( 'change' ) );
		childSelect.dispatchEvent( new Event( 'change' ) );
	}


	checkForOnRequestPriceModel() {
		// Standardmäßig wird angenommen, dass alle Preise berechnet werden können
		this.cartCalculates = true;

		// Durchlaufe alle Artikel im Warenkorb
		for ( const packageId in this.cart ) {
			if ( this.cart.hasOwnProperty( packageId ) ) {
				const item = this.cart[ packageId ];

				// Wenn ein Artikel das Preis-Modell 'on_request' hat, setze cartCalculates auf false
				if ( item.priceModel === 'on_request' ) {
					this.cartCalculates = false;
					break; // Keine weiteren Überprüfungen erforderlich
				}
			}
		}

		// Finde das Preis-Element für das Grand Total
		const totalPriceElement = document.querySelector( '.carttotal .price' );

		if ( !totalPriceElement ) {
			// console.log( 'Fehler: Konnte das Preis-Element für das Grand Total nicht finden.' );
			return;
		}

		// Aktualisiere das Preis-Element entsprechend dem Zustand von cartCalculates
		if ( !this.cartCalculates ) {
			totalPriceElement.textContent = 'auf Anfrage';
		} else {
			// Optional: Berechne den regulären Gesamtpreis, falls cartCalculates true ist
			this.calculateGrandTotal();
		}
	}


	// Methode zur Validierung des Warenkorbs
	validateCart() {
		// Überprüfe, ob mindestens ein Workshop im Warenkorb ist
		const hasWorkshops = Object.keys( this.cart ).length > 0;

		// Überprüfe, ob genug Eintrittskarten vorhanden sind
		const maxWorkshopAttendees = Math.max( ...Object.values( this.cart ).map( item => parseInt( item.attendeeCount ) || 1 ), 0 );
		const totalTickets = this.entranceTickets.ticketcountAdult + this.entranceTickets.ticketcountChild;
		const hasEnoughTickets = totalTickets >= maxWorkshopAttendees;

		// Setze den cartIsValid-Wert
		this.cartIsVaild = hasWorkshops && hasEnoughTickets;
		// console.log( `Warenkorb ist gültig: ${this.cartIsVaild}` );
	}


	formatPrice( price ) {

		// const formattedPrice = price % 1 === 0 ? `${price.toFixed(0)},-` : price.toFixed( 2 ).replace( '.', ',' );
		// return formattedPrice;

		// return price.toLocaleString('de').toFixed( 2 );
		// return price.toFixed( 2 ).replace( '.', ',' );
		return price.toLocaleString('de-de', {style:"currency", currency:"EUR"} );
	}


	updateFloatingCart() {
		const cartToggle = document.querySelector( '#floatingCartToggle' );
		const counterElement = cartToggle.querySelector( '.counter .number' );
		const totalElement = cartToggle.querySelector( '.total' );

		// Berechne die Anzahl der Artikel im Warenkorb
		const itemCount = Object.keys( this.cart ).length;

		// Berechne den Gesamtpreis der Artikel im Warenkorb
		const totalPrice = this.totals.Total || 0;

		// Aktualisiere den Zähler
		counterElement.textContent = itemCount;

		// Wenn totalPrice 0 ist, aber itemCount > 0, schreibe "a.A." ins totalElement
		if ( totalPrice === 0 && itemCount > 0 ) {
			totalElement.textContent = "Preis auf Anfrage";
		} else {
			// totalElement.textContent = `${this.formatPrice(totalPrice)} Euro`;
			totalElement.textContent = `${this.formatPrice(totalPrice)}`;
		}

		// Ändere die Breite des #floatingCartToggle basierend auf der Anzahl der Artikel
		if ( itemCount > 0 ) {
			const maxWidth = Math.min( 500, window.innerWidth * 0.8 );
			cartToggle.style.width = `${maxWidth}px`;
			cartToggle.classList.remove( 'disabled' );
		} else {
			cartToggle.style.width = '300 px'; // Beispielhafte eingeklappte Breite

			cartToggle.classList.add( 'disabled' );

		}
	}


	clearEntranceTickets() {
		// Setze alle Eintrittskarten-Werte zurück
		this.entranceTickets.ticketcountAdult = 0;
		this.entranceTickets.ticketcountChild = 0;

		// Konsolenmeldung zur Überprüfung
		console.log( 'Eintrittskartenwerte wurden zurückgesetzt:', this.entranceTickets );

		// Optional: Preis im DOM aktualisieren
		const priceElement = document.querySelector( `.cartentrance .price` );
		if ( priceElement ) {
			priceElement.textContent = '0,00 Euro';
		}

		// Setze die Ticket-Gesamtsumme auf 0
		this.totals.ticketTotal = 0;
	}





}

// Instanziiere die Klasse und mache sie global verfügbar

document.addEventListener( 'DOMContentLoaded', function() {
	// Prüfe, ob das Formular mit der ID "waldwelt-cart" existiert
	const cartForm = document.getElementById( 'waldwelt-cart' );
	if ( !cartForm ) {
		return; // Beende das Script, wenn das Formular nicht vorhanden ist
	}

	// console.log( "starte Warenkorb ..." );

	window.waldweltCart = new WaldweltCart();
	if ( document.querySelector( 'select[name="anzahl_eintritt_erwachsene"]' ) ) {
		waldweltCart.configureEntranceTickets();
		waldweltCart.updateMaxWorkshopAttendees();
	}


	const floatingCartToggle = document.querySelector( '#floatingCartToggle' );
	//floatingCartToggle.style.width = '300px'; // Beispielhafte eingeklappte Breite
	const maxWidth = Math.min( 300, window.innerWidth * 0.8 );
	floatingCartToggle.style.width = `${maxWidth}px`;



	// Event-Listener für die Buttons hinzufügen
	document.querySelectorAll( '.btn-primary.addtocart' ).forEach( ( button ) => {
		button.addEventListener( 'click', function( event ) {
			event.preventDefault();


			if ( button.classList.contains( 'selected' ) ) {

				// remove form cart
				const packageId = this.getAttribute( 'data-package-id' );
				console.log( "remove 1" + packageId );

				waldweltCart.removeItemFromDOM( packageId );

			} else {
				// Erfasse die Daten aus den data-Attributen des Buttons
				const item = {
					packageId: this.getAttribute( 'data-package-id' )
					, angebotsname: this.getAttribute( 'data-angebotsname' )
					, priceModel: this.getAttribute( 'data-price-model' )
					, attendeeCount: parseInt( this.getAttribute( 'data-attendee-count' ), 10 ) || 1
					, maxAttendeeCount: parseInt( this.getAttribute( 'data-max-attendee-count' ) )
					, pricePerPerson: parseFloat( this.getAttribute( 'data-price-per-person' ).replace( ',', '.' ) )
					, pricePerGroup: parseFloat( this.getAttribute( 'data-group-price' ).replace( ',', '.' ) )
					, includesParkEntry: this.getAttribute( 'data-includes-parkentry' ) === 'true'
					, tieredPricing: null
				};

				// Parst das `data-tiered-price` JSON, falls vorhanden
				const tieredPriceData = this.getAttribute( 'data-tiered-price' );
				if ( tieredPriceData ) {
					try {
						// JSON in ein Array parsen und nur gültige Werte beibehalten
						const parsedData = JSON.parse( tieredPriceData ).filter( tier => {
							const minPersonsValid = /^[0-9]+([.,][0-9]+)?$/.test( tier.min_persons );
							const pricePerValid = /^[0-9]+([.,][0-9]+)?$/.test( tier.price_per_person );
							if ( minPersonsValid && pricePerValid ) {
								// Ersetze "," durch "." und wandle Werte in Floats um
								tier.min_persons = parseFloat( tier.min_persons.toString().replace( ',', '.' ) );
								tier.price_per = parseFloat( tier.price_per_person.toString().replace( ',', '.' ) ); // Umbenennen zu price_per
								delete tier.price_per_person; // Entferne das alte price_per_person Feld
								return true;
							}
							return false;
						} );

						item.tieredPricing = parsedData;
					} catch ( error ) {
						console.error( "Fehler beim Parsen der tieredPricing Daten:", error );
					}
				}

				// Füge den Artikel zum Warenkorb hinzu, wenn er nicht bereits vorhanden ist
				waldweltCart.addToCart( item );


			}
		} );

	} );



} );



// Warenkorb Schublade
// Selektiere alle Toggle-Buttons
document.querySelectorAll( '.cart-toggle' ).forEach( function( button ) {
	button.addEventListener( 'click', function() {
		const cart = document.querySelector( '.waldwelt-cart.drawer' );

		// Überprüfe, ob der Button die Klasse .cart-close hat
		if ( button.classList.contains( 'cart-close' ) ) {
			// Schließe den Warenkorb, falls er geöffnet ist
			if ( cart.classList.contains( 'open' ) ) {
				cart.classList.remove( 'open' );
			}
			return; // Beende die Funktion, wenn der Button nur zum Schließen gedacht ist
		}

		// Standardmäßiges Verhalten: Öffnen/Schließen des Warenkorbs
		if ( Object.keys( waldweltCart.cart ).length === 0 ) {
			console.log( "Warenkorb ist leer. Öffnen nicht möglich." );
			return; // Warenkorb ist leer, daher Öffnen verhindern
		}

		cart.classList.toggle( 'open' );
	} );



} );

document.addEventListener( 'DOMContentLoaded', function() {
	const enableTicketCheckbox = document.getElementById( 'enableTicketCalculation' );
	const cartEntranceBlock = document.getElementById( 'cartEntranceBlock' );

	// Beenden, wenn waldweltCart oder enableTicketCheckbox nicht existieren
	if ( !window.waldweltCart || !enableTicketCheckbox ) {
		return;
	}


	window.waldweltCart.enableTicketCalculation = false; // Eintrittskarten standardmäßig deaktiviert




	// Event-Listener für die Checkbox
	enableTicketCheckbox.addEventListener( 'change', function() {
		const isEnabled = enableTicketCheckbox.checked;
		waldweltCart.enableTicketCalculation = isEnabled;

		if ( isEnabled ) {
			cartEntranceBlock.classList.remove( 'd-none' );

			// Aktualisiere die Eintrittskarten-Werte aus den Select-Feldern
			const adultSelect = document.querySelector( 'select[name="anzahl_eintritt_erwachsene"]' );
			const childSelect = document.querySelector( 'select[name="anzahl_eintritt_kinder"]' );

			waldweltCart.entranceTickets.ticketcountAdult = parseInt( adultSelect.value, 10 ) || 0;
			waldweltCart.entranceTickets.ticketcountChild = parseInt( childSelect.value, 10 ) || 0;

			// Preise basierend auf aktuellen Werten berechnen
			waldweltCart.updateEntrancePrice();
		} else {
			cartEntranceBlock.classList.add( 'd-none' );
			waldweltCart.clearEntranceTickets(); // Eintrittskartenwerte zurücksetzen
			waldweltCart.calculateGrandTotal(); // Grand Total aktualisieren
		}
	} );

} );